import { REINVITEMEMBER_SUCCESS, REINVITEMEMBER_FAIL } from '../actionTypes';

const initialState = {
    user: null,
    loading: false
};

const reinviteMemberReducer = (state = initialState, action) => {
    switch (action.type) {
        case REINVITEMEMBER_SUCCESS:
            return {
                ...state,
                loading: true,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case REINVITEMEMBER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }
    return state;
};

export default reinviteMemberReducer;
